<template>
    <rkm-area
        type="fieldset"
        title="Atividade"
    >

        <rkm-row v-if="data.model">
            <rkm-col cols="6">
                <rkm-form-select
                    :options="atividadeTipo"
                    textField="descricao"
                    valueField="id"
                    label="Atividade"
                    v-model="data.model.atividade.atividadeTipoId"
                    default-option-text="Selecione"
                    show-default-option
                    :validations="validations.atividadeTipo"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-model="data.model.atividade.totalParticipantes"
                    label="Participantes"
                    number
                    :validations="validations.participantes"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-model="data.model.atividade.avaliacoesAlteradas"
                    label="Avaliações alteradas"
                    number
                    readonly
                    :validations="validations.avaliacoesAlteradas"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
//Enums
import pse from '@/enums/atencao-basica/atividade-coletiva/pse'
import atividadeTipo from '@/enums/atencao-basica/atividade-coletiva/atividadeTipo'

export default {
    data: () => ({
        enums: {
            pse,
            atividadeTipo
        }
    }),
    computed: {
        validations() {
            return {
                atividadeTipo: {
                    required: true
                },
                participantes: {
                    required:true
                },
                avaliacoesAlteradas: {
                    max: 3
                }
            }
        },
        atividadeTipo() {

            if(this.data.model.cadastro.pseId == this.enums.pse.EDUCACAO) {
                return this.data.form.atividadeTipo.filter(atividade => atividade.id == this.enums.atividadeTipo.EDUCACAO_EM_SAUDE || atividade.id == this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO || atividade.id == this.enums.atividadeTipo.MOBILIZACAO_SOCIAL)
            } else {
                return this.data.form.atividadeTipo
            }
        }
    },
    props: {
        data: { type: Object, required: false, },
    }
}
</script>